import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_SALARIES, SET_EMPLOYEE_SALARY, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_SALARY_ISLOADING,
  DELETE_EMPLOYEE_SALARY,
  EDIT_EMPLOYEE_SALARY,
  GET_EMPLOYEE_SALARIES,
  GET_EMPLOYEE_SALARY,
  REGISTER_EMPLOYEE_SALARY,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeSalary from '@/services/employee_salary';
import { Module } from 'vuex';
import { EditEmployeeSalary, RegisterEmployeeSalary, GetEmployeeSalary } from '@/dtos/employee_salary.dto';

const employeeSalary: Module<any, {}> = {
  state: {
    employeeSalary: {
      data: null,
      isLoading: false,
    },
    employeeSalaries: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeSalary: (state: { employeeSalary: any }) => state.employeeSalary,
    employeeSalaries: (state: { employeeSalaries: any }) => state.employeeSalaries,
  },
  mutations: {
    [SET_EMPLOYEE_SALARY]: (
      state: { employeeSalary: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeSalary.data = payload.data) : null,
        (state.employeeSalary.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_SALARIES]: (
      state: { employeeSalaries: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeSalaries.data = payload.data) : null,
        (state.employeeSalaries.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_SALARY]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalary.registerEmployeeSalary(
        payload as RegisterEmployeeSalary
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_SALARY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_SALARIES]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARIES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalary.getEmployeeSalaries(
        payload as GetEmployeeSalary
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARIES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARIES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARIES, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_SALARY]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalary.getEmployeeSalaries(
        payload as GetEmployeeSalary
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_SALARY]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalary.editEmployeeSalary(
        payload as EditEmployeeSalary
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_SALARY]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeSalary.deleteEmployeeSalary(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_SALARY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_SALARY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_SALARY, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_SALARY_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_SALARY, { isLoading: false });
      commit(SET_EMPLOYEE_SALARIES, { isLoading: false });
    },
  },
};

export default employeeSalary;
